module.exports = __webpack_public_path__ + "static/media/55_000088.fcdee16a.jpg";